/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class BulkPrintRoute extends Route {
  // Services
  @service
  store;

  model() {
    let group = this.modelFor('group');
    return this.store.query('person', {
      groupId: group.id,
    });
  }
}
